import { createSelector } from '@ngrx/store';

import { TalentPoolsBriefSelectors } from './talent-pools-brief.store';
import { TalentPoolItemsSelectors } from './talent-pools.store';

const activeItemsAndArchivedBrief = createSelector(
  TalentPoolItemsSelectors.active,
  TalentPoolsBriefSelectors.archived,
  (active, archived) => [...active, ...archived],
);

const selectors = {
  activeItemsAndArchivedBrief,
};

export { selectors as TalentPoolsCombinedSelectors };
